import React from "react";

const Button = ({
	className,
	children,
	disabled,
	variant = "primary",
	...props
}) => {
	const baseStyles =
		"inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";

	const variantStyles = {
		primary:
			"bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 disabled:bg-blue-300",
		secondary:
			"bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-500 disabled:bg-gray-100",
		outline:
			"border border-gray-300 bg-transparent text-gray-700 hover:bg-gray-50 focus:ring-gray-500 disabled:text-gray-300",
	};

	return (
		<button
			className={`${baseStyles} ${variantStyles[variant]} ${
				disabled ? "cursor-not-allowed" : ""
			} ${className || ""}`}
			disabled={disabled}
			{...props}
		>
			{children}
		</button>
	);
};

export { Button };
